import { Component, Input, OnInit } from '@angular/core';
import { LegalDocumentsBloc } from '@kp/legal-document/legal-documents.bloc';
import { LegalDocumentType } from '@ktypes/models';

@Component({
  selector: 'kp-modal-policies',
  templateUrl: './modal-policies.component.html',
  styleUrls: ['./modal-policies.component.scss'],
})
export class ModalPoliciesComponent implements OnInit {
  constructor(public legalDocumentsBloc: LegalDocumentsBloc) {}

  @Input() policyText: string;
  @Input() policyType: LegalDocumentType;

  legalDocumentType = LegalDocumentType;
  showFullPolicy = false;
  eulaContent = '';
  privacyContent = '';

  ngOnInit(): void {
    void this.legalDocumentsBloc.fetchLegalDocuments(null);
  }

  isFullPolicyOpen(isOpen: boolean) {
    this.showFullPolicy = isOpen;
  }

  clickFullPolicyLink() {
    this.showFullPolicy = true;
  }
}
